/* eslint-disable no-return-assign */
import * as Utils from '../../utils/utils';

export default class DatavizSwitcher {
  constructor() {
    this.switcherWrapper = document.querySelector('.js-dataviz-switcher');

    if (this.switcherWrapper) {
      this.targets = [...document.querySelectorAll(this.switcherWrapper.dataset.target)];
      this.input = this.switcherWrapper.querySelector('.switch-checkbox');
      this.setup();
    }
  }

  setup() {
    this.input.addEventListener('change', () => {
      if (this.input.checked) {
        this.showContent(1);
      } else {
        this.showContent(0);
      }
    });

    this.showContent(0);
  }

  showContent(index) {
    const element = document.querySelector(`[data-index-product="${index}"]`);
    const btnTab = document.querySelector('[data-tab][data-active=true]');
    const inactiveBtnTab = document.querySelector('[data-tab]:not([data-active=true])');

    this.targets.forEach((target) => {
      target.style.display = 'none';
      Utils.removeClass(target, 'selected');
    });

    inactiveBtnTab.click();

    element.style.display = 'block';
    Utils.addClass(element, 'selected');

    const activeTab = document.querySelector('.js-bubbles.selected .tab.active');
    const inactiveTab = document.querySelector('.js-bubbles.selected .tab:not(active)');

    Utils.removeClass(activeTab, 'active');
    Utils.addClass(inactiveTab, 'active');
    btnTab.click();
  }
}
